import { apiDelete, apiJson } from './client.js'

export function getEngineApiClients() {
  return apiJson('/admin/engine-management/clients', {}, 'Failed to load Engine API clients')
}

export function createEngineApiClient(payload) {
  return apiJson(
    '/admin/engine-management/clients',
    { method: 'POST', body: JSON.stringify(payload) },
    'Failed to create Engine API client',
  )
}

export function revokeEngineApiClient(clientId) {
  return apiDelete(`/admin/engine-management/clients/${clientId}`, 'Failed to revoke Engine API client')
}
